import UPFileInput from './UPFileInput';

export default UPFileInput;
